import { createAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { responseTypes } from "utils/Types";
import { axiosPost } from "../../../utils/APIHelper";
import { PlanState } from "./plans";

const initialState: PlanState = {
  list: [],
  brandDeadlines: [],
  initiativePlans: [],
  totalRecords: 0,
  status: "idle",
  showDialog: false,
  errors: "",
  planShowLoader: false
  //add error field
  //test
};

export const fetchPlansAsync = createAsyncThunk("plans/fetchPlans", async (data: any, thunkApi) => {
  const API_URL = `plans?externalHltId=${data?.externalHltId || ""}`;
  const response: any = await axiosPost(API_URL, "", {
    ...data
  });

  if (
    response?.response?.status >= responseTypes.internal_error &&
    response?.response?.status < responseTypes.other_error
  ) {
    return thunkApi.rejectWithValue(response.response);
  }

  return response.data;
});

export const closeDialog = createAction("plans/clearState");

export const PlansSlice = createSlice({
  name: "plans",
  initialState,
  reducers: {
    clearPlanList: (state) => {
      state.list = [];
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(closeDialog, (state) => {
        state.showDialog = false;
      })
      .addCase(fetchPlansAsync.pending, (state, action: any) => {
        state.planShowLoader = action.meta.arg.pagination.page === 1;
        state.status = action.meta.arg.pagination.page === 1 ? "loading" : "idle";
      })
      .addCase(fetchPlansAsync.fulfilled, (state, action: any) => {
        state.planShowLoader = false;
        state.status = "idle";
        state.totalRecords = action?.payload?.meta?.page?.total;

        state.list =
          action.meta.arg.pagination.page === 1 ? action.payload.plans : [...state.list, ...action.payload.plans];
      })
      .addCase(fetchPlansAsync.rejected, (state) => {
        state.planShowLoader = false;
        state.status = "failed";
      });
  }
});

export const { clearPlanList } = PlansSlice.actions;

export default PlansSlice.reducer;
